import { func, number } from 'prop-types';
import React from 'react';
import { FaLongArrowAltRight } from 'react-icons/fa';

function PageNavButtons({ curPage, totalPages, paginateUser }) {
    return (
        <span>
            {curPage < totalPages ? (
                <FaLongArrowAltRight
                    onClick={() => paginateUser(curPage + 1)}
                    style={{
                        cursor: 'pointer',
                    }}
                    size={28} />
            ) : null}
        </span>
    );
}

PageNavButtons.propTypes = {
    curPage: number,
    totalPages: number,
    paginateUser: func,
};

export default PageNavButtons;